$exso_sheets_dashboard $mol_page
	date_moment $mol_time_moment
	shifts /$exso_sheets_shift
	slice_shifts /$exso_sheets_shift
	month_shifts /$exso_sheets_shift
	blowings /$exso_sheets_blowing
	plans /$exso_sheets_plan
	title_content / <= title 
	stats /
		*
			icon \$mol_icon_screw_lag
			plan \burnt
			items / * shift \value
		*
			title \Взрывы
			icon \$mol_icon_bomb
			plan \blast
			items / * blowing \blasted
				* value \blast
				* month \blast
		*
			icon \$mol_icon_fuel
			items /
				* shift \fuel
				* 
					shift \fuel__value
					type \slice
		*
			icon \$mol_icon_blur
			items /
				* shift \wells_count
				* shift \redrill
		*
			icon \$mol_icon_pause_circle_outline
			items /
				* shift \downtime
				* shift \org_downtime
				* shift \tech_downtime
	body /
		<= Cards $mol_row sub /
			<= Logo $mol_view sub / <= Logo_content $exso_logo
			^ cards / <= Card*0 $mol_view sub /
				<= Card_icon* <= Stat_icon* $mol_icon_pickaxe
				<= Card_column* $mol_list rows /
					<= Card_title* $mol_view sub / <= stat_title* \
					<= Card_value* $mol_view sub / <= stat_value* \
		<= Sites $mol_section
			title @ \Участки
			content / <= Sites_list $mol_row sub <= sites_list / <= Site*0 $mol_link
				arg <= site_arg* *
				sub / <= Site_content* $mol_list rows /
					<= Site_head* $mol_row sub /
						<= Site_title* $mol_list rows /
							<= Site_name* $mol_view sub / <= site_name* \
							<= site_meta* @ \{d} станков, {s} смен
						<= Site_progresses* $mol_row sub <= site_progresses* / <= Site_progress* $mol_view
							attr * progress_type <= site_progress_type* \medium
							sub /
								<= Site_progress_icon* $mol_icon_pickaxe
								<= site_progress_percent* \0%
					<= Site_stats* $mol_row sub <= site_stats* / <= Site_stat* $mol_list
						attr *
							progress_type <= site_progress_type*
							stat_type <= stat_type* \
						style *
							^
							\--width
								<= site_progress_style* \0%
						rows /
							<= Site_stat_title* $mol_view sub /
								<= Site_stat_icon* $mol_icon_pickaxe
								<= site_stat_title* \
							^ site_stat_items* / <= Site_stat_item* $exso_sheets_dashboard_row
								label <= site_stat_label* <= fact_label @ \Факт
								value <= site_stat_value* \
							^ site_plan_items* / <= Site_plan_item* $exso_sheets_dashboard_row
								label <= site_plan_label* <= plan_label @ \План
								value <= site_plan_value* \
$exso_sheets_dashboard_row $mol_view sub /
	<= Label $mol_view sub / <= label \
	<= Value $mol_view sub / <= value \
